// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__35OwR","left":"StickyBox_left__1KdDO","right":"StickyBox_right__1LgTz"};